import React from 'react';
import PropTypes from 'prop-types';

const Placeholder = (props) => <div {...props} className="ws-ui-language-select-placeholder" />;

Placeholder.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Placeholder;
